import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const RetirementCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='24dd07f7-5dc6-45a3-b895-9e261a54bd15' />
}

export default React.memo(RetirementCalculatorBlock)
